<div class="activity-details solo">
    <c-auto-form config="classify.autoFormConfig"></c-auto-form>
</div>